export default __webpack_public_path__ + "static/media/Gloves of Dark Malice.12c43025.jpg";